import { LuEye, LuRocket } from 'react-icons/lu';
import { GoDotFill } from 'react-icons/go';
import SectionLabel from '../components/SectionLabel';
import StickmanTimeline from '../components/StickmanTimeline';
import useDocumentTitle from '../hooks/useDocumentTitle';

const aboutHeroImg = require('../Assert/12.jpg');

function About() {
  useDocumentTitle('About MMI — Reawakened Intelligence');

  return (
    <main className="about-page">
      {/* Hero Section - Reawakened One */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-grid">
            <div className="about-hero-media">
              <div className="assert-image-wrap">
                <img src={aboutHeroImg} alt="About MMI" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
            <div className="about-hero-text">
              <h1 className="hero-title">
                We're Not a New Company.
                <br />
                We're a <span className="gradient-text">Reawakened One.</span>
              </h1>
              <p className="hero-description">
                MMI was building immersive digital systems before AI companies existed.
                <br />
                We paused. We watched. Now we are back —
                <br />
                with a decade of context no one else has.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Evolution Section */}
      <section className="evolution-section">
        <div className="container">
          <div className="evolution-header">
            <SectionLabel text="OUR EVOLUTION" />
            <h2 className="evolution-title">
              <span className="gradient-text">THE REAL STORY</span>
            </h2>
          </div>
        </div>

        <StickmanTimeline />
      </section>

      {/* Vision & Mission Cards */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="vision-mission-header">
            <div className="vision-mission-header-desktop">
              <SectionLabel text="The Vision" />
              <SectionLabel text="The Mission" />
            </div>
            <div className="vision-mission-header-mobile">
              <SectionLabel text="VISION & MISSION" />
            </div>
          </div>

          <div className="vision-mission-grid">
            <div className="feature-card vision-card">
              <div className="feature-iconBadge">
                <LuEye size={22} />
              </div>
              <div className="feature-watermark" aria-hidden>
                <LuEye size={120} />
              </div>
              <h2 className="feature-title">
                Where We are <span className="gradient-text">Going</span>
              </h2>
              <p className="feature-description">
                A world where intelligent systems handle the complex, the repetitive, 
                and the impossible — so humans can focus on what only humans can do.
              </p>
            </div>

            <div className="feature-card mission-card">
              <div className="feature-iconBadge">
                <LuRocket size={22} />
              </div>
              <div className="feature-watermark" aria-hidden>
                <LuRocket size={120} />
              </div>
              <h2 className="feature-title">
                To build AI and immersive systems that are <span className="gradient-text">genuinely useful</span>
              </h2>
              <p className="feature-description">
                — not impressive demos, not VC pitch decks. Real products. Real results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section">
        <div className="container">
          <SectionLabel text="WHAT DRIVES US" />
          <h2 className="values-title">Core Values</h2>

          <div className="values-list">
            <div className="value-row">
              <GoDotFill className="value-dot" />
              <span className="value-text">Obsession <span className="value-over">over obligation</span></span>
            </div>
            <div className="value-row">
              <GoDotFill className="value-dot" />
              <span className="value-text">Depth <span className="value-over">over hype</span></span>
            </div>
            <div className="value-row">
              <GoDotFill className="value-dot" />
              <span className="value-text">Craft <span className="value-over">over speed</span></span>
            </div>
            <div className="value-row">
              <GoDotFill className="value-dot" />
              <span className="value-text">Resilience <span className="value-over">over comfort</span></span>
            </div>
            <div className="value-row">
              <GoDotFill className="value-dot" />
              <span className="value-text">Autonomy <span className="value-over">over control</span></span>
            </div>
          </div>
        </div>
      </section>

      
    </main>
  );
}

export default About;